import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import Auth from '../../auth/Auth';
import { useDispatch } from 'react-redux';
import AppContext from '../context/AppContext';
import { authorizeToken } from '../_slice/onboardingSlice';

function OnboardingLayout() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setLoader } = useContext(AppContext);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const orgId = urlParams.get("orgId");
        const token = urlParams.get("token");

        if (token && !isAuthorized) {
            setIsAuthorized(true);
            handleTokenAuth(orgId, token);
        }
    }, []);

    const handleTokenAuth = async (orgId, token) => {

        if (!orgId || !token) {
            // console.warn("Missing orgId or token. Authorization skipped.");
            return;
        }

        try {
            setLoader(true);
            const result = await dispatch(authorizeToken({ orgId, token, setLoader }));
            const { payload } = result;

            if (payload?.token) {
                // console.log('payload?.token', payload?.token);

                // Remove the old token first
                localStorage.removeItem("loci_token");
                // Set the new token
                localStorage.setItem("loci_token", payload?.token);
                setIsAuthorized(true);
                // console.log("Token stored in localStorage and user is authenticated.");

                // Remove orgId and token from the URL
                const newUrl = `${window.location.origin}/#/organization`;
                window.history.replaceState({}, document.title, newUrl);

                navigate("/organization", { replace: true });
                window.location.reload();
            } else {
                console.warn("No token received in the response.");
            }
        } catch (error) {
            console.error("Token Authorization Failed:", error);
        } finally {
            setLoader(false);
        }
    };

    if (Auth.isUserAuthenticated()) {
        return <Navigate to="/organization" replace />;
    }
    return (
        <div className="onboard">
            {/* Container for onboarding content */}
            <div className="onboard-container">
                {/* Outlet component renders the child routes */}
                <Outlet />
            </div>
        </div>
    );
}

export default OnboardingLayout;